import * as React from "react";
const SvgFiRrDragon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-dragon_svg__a)">
      <path
        fill="#062147"
        d="M21.999 18.467c0 4.068-4.484 5.533-7.499 5.533h-2C6.427 24 .003 18.092 0 12.504v-.006c0-2.054.425-4.742 2.076-7.494H.523a.518.518 0 0 1-.367-.885C1.82 2.484 3.879.882 5.274.085a.652.652 0 0 1 .971.564c.011 2.044-.423 4.446-.836 6.422-.112.534-.851.591-1.044.08l-.681-1.627C2.994 7.441 2.001 8.5 2.001 12.5c0 3.97 5.527 8 9.5 8 1.21 0 3.5-.313 3.5-1.5 0-.607-.709-1.213-1.638-1.837l-3.295.843a.46.46 0 0 1-.512-.656l1.163-1.89a17 17 0 0 1-.632-.459h-3.61a.494.494 0 0 1-.349-.843l1.869-1.305a6 6 0 0 1-.489-.89l-3.05-.239a.473.473 0 0 1-.216-.855l2.78-1.594c.048-.36.216-1.44.575-2.202a1 1 0 0 1 1.81.853c-.218.462-.36 1.3-.404 1.632.033 2.528 2.218 3.893 4.332 5.212 1.887 1.178 3.668 2.29 3.668 4.23 0 1.535-1.006 2.482-2.382 2.998 1.52-.034 5.382-.716 5.382-3.499-.086-2.584-1.571-4.16-4.868-6.709a1 1 0 0 1-.18-1.402 1 1 0 0 1 1.402-.18c3.228 2.493 5.521 4.546 5.645 8.258zM19.999 5H23a1 1 0 1 0 0-2h-3.463A2.59 2.59 0 0 0 17.5 2h-.698c-.824-.863-.97-1.369-1.106-1.635-.092-.18-.164-.365-.365-.365a.366.366 0 0 0-.365.365c0 .923.057 1.347.18 2.016-.931-.444-2.407-1.79-2.997-2.283-.303-.253-.752.018-.678.406.164.866 1.117 2.52 1.665 3.307-1.551-.173-3.676-.633-4.671-.81-.368-.067-.614.37-.362.647.776.854 2.779 2.332 5.007 2.966-.524.674-.969 2.041-1.133 2.81a.472.472 0 0 0 .712.501C13.621 9.336 15.303 8 16.501 8c2.505 0 4.107 1.094 4.84 1.746a.996.996 0 0 0 1.412-.082 1 1 0 0 0-.082-1.412 9 9 0 0 0-4.148-2.049C18.703 5.02 19.958 5 20 5z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-dragon_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrDragon;
